/* Cookie consent behaviour.

   Two jobs.

   1. Remember the answer. Nothing in the page wrote the choice anywhere, which
      is why the banner asked again on every visit. It is now stored for twelve
      months, and a returning visitor never sees it.

   2. Play the animation properly. Accept gets the cookie monster; Reject keeps
      the sad burst, larger and slower. The banner is held open until the
      animation finishes, then the page's own accept and reject logic runs
      untouched, so consent still does whatever it did before.

   This registers its listeners immediately rather than on DOMContentLoaded, so
   it captures the click before the page's own reaction script, which registers
   later. That is deliberate and load order matters. */
(function () {
  var KEY = 'rk_cookie_choice';
  var MONTHS = 12;
  var HOLD = 2400;         // was 1150. Long enough to watch the monster.
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function remembered() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.at) return null;
      var age = (window.RK_NOW || 0) ? 0 : 0; // no clock arithmetic beyond the stored stamp
      if (typeof v.exp === 'number' && v.exp < new Date().getTime()) return null;
      return v;
    } catch (e) { return null; }
  }

  function remember(choice) {
    try {
      var now = new Date().getTime();
      localStorage.setItem(KEY, JSON.stringify({
        choice: choice,
        at: now,
        exp: now + MONTHS * 30 * 24 * 60 * 60 * 1000
      }));
    } catch (e) {}
  }

  /* A returning visitor should never be asked again. */
  function hideIfAnswered() {
    if (!remembered()) return false;
    var el = document.getElementById('cookie');
    if (el) { el.style.display = 'none'; el.setAttribute('aria-hidden', 'true'); }
    return true;
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function crumbs(scene, n) {
    for (var i = 0; i < n; i++) {
      var c = el('span', 'rk-ck-crumb');
      var ang = (Math.PI * 2 * i) / n + (i % 3) * 0.3;
      var dist = 70 + (i * 17) % 90;
      c.style.setProperty('--cx', (Math.cos(ang) * dist).toFixed(1) + 'px');
      c.style.setProperty('--cy', (Math.sin(ang) * dist + 60).toFixed(1) + 'px');
      c.style.setProperty('--cr', (((i * 71) % 360) - 180) + 'deg');
      c.style.animationDelay = (0.62 + (i % 5) * 0.05) + 's';
      c.style.background = (i % 4 === 0) ? '#5a3a15' : '#8a5a22';
      scene.appendChild(c);
    }
  }

  var COOKIE_SVG =
    '<svg viewBox="0 0 132 132" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<defs><mask id="rkCkBite"><rect width="132" height="132" fill="#fff"/>' +
    '<circle cx="116" cy="52" r="26" fill="#000"><animate attributeName="r" values="0;0;26;26" keyTimes="0;.30;.34;1" dur="2.4s" fill="freeze"/></circle>' +
    '<circle cx="104" cy="96" r="22" fill="#000"><animate attributeName="r" values="0;0;22;22" keyTimes="0;.50;.54;1" dur="2.4s" fill="freeze"/></circle>' +
    '</mask></defs>' +
    '<g mask="url(#rkCkBite)">' +
    '<circle cx="66" cy="66" r="62" fill="#d9a05b"/>' +
    '<circle cx="66" cy="66" r="62" fill="none" stroke="#b9813f" stroke-width="4"/>' +
    '<circle cx="44" cy="44" r="9" fill="#4a2c12"/><circle cx="84" cy="38" r="7" fill="#4a2c12"/>' +
    '<circle cx="38" cy="84" r="8" fill="#4a2c12"/><circle cx="72" cy="78" r="10" fill="#4a2c12"/>' +
    '<circle cx="58" cy="104" r="6" fill="#4a2c12"/><circle cx="98" cy="70" r="6" fill="#4a2c12"/>' +
    '</g></svg>';

  var MONSTER_SVG =
    '<svg viewBox="0 0 190 170" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<g fill="#2d8cf0">' +
    '<circle cx="104" cy="86" r="66"/>' +
    '<circle cx="52" cy="52" r="13"/><circle cx="46" cy="84" r="11"/><circle cx="58" cy="118" r="12"/>' +
    '<circle cx="92" cy="22" r="13"/><circle cx="134" cy="28" r="11"/><circle cx="162" cy="58" r="12"/>' +
    '<circle cx="168" cy="100" r="11"/><circle cx="146" cy="140" r="12"/><circle cx="104" cy="152" r="11"/>' +
    '</g>' +
    '<g class="rk-ck-jaw"><path d="M44 92 A62 62 0 0 0 158 112 L44 92 Z" fill="#17324f"/>' +
    '<path d="M60 98 l10 9 10-9 10 9 10-9 10 9 10-9" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round"/></g>' +
    '<g><circle cx="88" cy="52" r="22" fill="#fff"/><circle cx="128" cy="48" r="20" fill="#fff"/>' +
    '<g class="rk-ck-pupil"><circle cx="84" cy="56" r="9" fill="#0a0f1c"/><circle cx="124" cy="52" r="8" fill="#0a0f1c"/></g></g>' +
    '</svg>';

  function monster() {
    var stage = el('div', 'rk-ck-stage dim');
    var scene = el('div', 'rk-ck-scene');
    var cookie = el('div', 'rk-ck-cookie');
    var mon = el('div', 'rk-ck-mon');
    var yum = el('div', 'rk-ck-yum');
    cookie.innerHTML = COOKIE_SVG;
    mon.innerHTML = MONSTER_SVG;
    yum.textContent = 'Yum!';
    scene.appendChild(cookie);
    scene.appendChild(mon);
    crumbs(scene, 16);
    scene.appendChild(yum);
    stage.appendChild(scene);
    document.body.appendChild(stage);
    setTimeout(function () { if (stage.parentNode) stage.parentNode.removeChild(stage); }, HOLD + 200);
  }

  /* Reject keeps the page's own idea, just bigger and slower. */
  var SAD = ['😢', '💧', '🥲', '💔', '🍪'];
  function sadBurst(btn) {
    var r = btn.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    for (var i = 0; i < 22; i++) {
      var s = el('span', 'ck-particle');
      s.textContent = SAD[i % SAD.length];
      s.style.left = cx + 'px';
      s.style.top = cy + 'px';
      s.style.setProperty('--tx', ((i % 2 ? 1 : -1) * (30 + (i * 21) % 180)) + 'px');
      s.style.setProperty('--ty', (50 + (i * 19) % 170) + 'px');
      s.style.setProperty('--rot', (((i * 53) % 360) - 180) + 'deg');
      s.style.animationDuration = (1.6 + (i % 4) * 0.2) + 's';
      s.style.fontSize = (26 + (i % 4) * 7) + 'px';   // was 16 to 28
      document.body.appendChild(s);
      s.addEventListener('animationend', function () { this.remove(); });
    }
  }

  function wire(id, choice) {
    var btn = document.getElementById(id);
    if (!btn) return;
    btn.addEventListener('click', function (ev) {
      if (btn._rkCk) return;              // the synthetic re-fire passes straight through
      btn._rkCk = true;
      btn._done = true;                   // tells the page's own reaction script to stand down
      ev.stopImmediatePropagation();

      remember(choice);

      if (REDUCE) { btn.click(); return; }

      if (choice === 'accept') { btn.textContent = 'Yum! 🍪'; btn.classList.add('ck-happy'); monster(); }
      else { btn.textContent = 'Aw, okay 🥲'; btn.classList.add('ck-sad'); sadBurst(btn); }

      setTimeout(function () { btn.click(); }, HOLD);
    }, true);
  }

  function boot() {
    if (hideIfAnswered()) return;
    wire('ckAccept', 'accept');
    wire('ckReject', 'reject');
    var save = document.getElementById('ckSave');
    if (save) save.addEventListener('click', function () { remember('custom'); }, true);
  }

  /* Deliberately not waiting for DOMContentLoaded: the listeners must be in
     place before the page's own reaction script registers its own. */
  if (document.getElementById('cookie')) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
